// 医生、科普模块共用，接口节点为 data，连线为 links。
export function buildSankeyOption(sankey) {
    return {
        tooltip: { trigger: 'item' },
        series: [
            {
                type: 'sankey',
                emphasis: { focus: 'adjacency' },
                data: sankey.data || [],
                links: sankey.links || [],
                nodeAlign: 'justify',
                // 小权重节点仍保留足够间距，避免节点高度趋近 0 时标签重叠。
                nodeGap: 24,
                top: 20,
                bottom: 20,
                // 为最右侧名称留出空间，超长名称可悬浮查看完整内容。
                right: 200,
                lineStyle: {
                    color: 'gradient',
                    curveness: 0.5,
                    opacity: 0.45,
                },
                itemStyle: {
                    borderWidth: 0,
                },
                label: {
                    color: '#333',
                    fontSize: 12,
                    lineHeight: 18,
                    width: 180,
                    overflow: 'truncate',
                },
                levels: [
                    {
                        depth: 0,
                        itemStyle: { color: '#165DFF' },
                    },
                    {
                        depth: 1,
                        itemStyle: { color: '#386DE8' },
                    },
                    {
                        depth: 2,
                        itemStyle: { color: '#6B9FFF' },
                    },
                ],
            },
        ],
    };
}
